import React, { CSSProperties } from 'react'
import { CgSpinner as LoadingIcon } from 'react-icons/cg'

interface ButtonProps {
	children: React.ReactNode
	className?: string
	loading?: boolean
	style?: CSSProperties
	disabled?: boolean
	type?: 'button' | 'submit' | 'reset'
	onClick?: () => void
	variant?: 'primary' | 'secondary' | 'tertiary'
}

const Button: React.FC<ButtonProps> = ({
	children,
	className = '',
	loading = false,
	style,
	disabled = false,
	type = 'button',
	onClick,
	variant
}) => {
	let additionalStyling = ''

	switch (variant) {
		case 'primary':
			additionalStyling =
				'bg-gradient-to-r from-orange-600 to-orange-500 text-white hover:text-white font-semibold shadow'
			break
		case 'secondary':
			additionalStyling =
				'bg-gradient-to-r from-slate-100 to-slate-200 text-dark hover:text-dark font-semibold shadow-sm'
			break
		case 'tertiary':
			additionalStyling =
				'bg-gradient-to-r from-clay-100 to-orange-100 text-dark hover:text-dark font-semibold shadow-sm'
			break
		default:
			additionalStyling = ''
	}

	return (
		<button
			type={type}
			className={`${className} ${additionalStyling} flex w-fit justify-center gap-2 rounded-full px-4 py-2 transition-all duration-500 ease-in-out`}
			style={style}
			disabled={disabled || loading}
			onClick={onClick}
		>
			{children}
			{loading && <LoadingIcon className="my-auto animate-spin" />}
		</button>
	)
}

export default Button
